import { render, staticRenderFns } from "./EventDetailsComponent.vue?vue&type=template&id=397edb8b&scoped=true&"
import script from "./EventDetailsComponent.vue?vue&type=script&lang=ts&"
export * from "./EventDetailsComponent.vue?vue&type=script&lang=ts&"
import style0 from "./EventDetailsComponent.vue?vue&type=style&index=0&id=397edb8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397edb8b",
  null
  
)

export default component.exports